import { NgModule } from '@angular/core';

import { AUTH_CONFIG_PROVIDER, AuthStateModule } from '@rx-applications/shared/auth/api';

@NgModule({
  imports: [AuthStateModule],
  providers: [...AUTH_CONFIG_PROVIDER],
})
export class AuthModule {}
